import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import styled from 'styled-components';
import diamondsBackground from 'assets/images/join/diamondsBackground.png';
import { BlueLink } from 'components/common/link';
import { SuccessPageMobile } from './success-page-mobile';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 0px;
  @media (max-width: 1000px) {
    margin-top: 300px;
  }
`;
const FirstText = styled.div`
  margin-top: 80px;
  font-family: ${props => props.theme.fonts.montserratMedium};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 30px;
  text-align: center;
  width: 560px;
  padding-bottom: 7px;
  margin-bottom: 25px;
`;
const SecondText = styled.div`
  font-family: ${props => props.theme.fonts.montserratMedium};
  font-size: 17px;
  text-align: center;
  white-space: break-spaces;
  z-index: 1;
`;
const BoldText = styled.div`
  font-family: ${props => props.theme.fonts.montserratBold};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 17px;
  text-align: center;
  white-space: break-spaces;
`;
const ThirdText = styled.div`
  font-family: ${props => props.theme.fonts.montserratMedium};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 19px;
  text-align: center;
  white-space: break-spaces;
`;
const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.montserratBold};
  font-size: 17px;
  text-decoration: auto;
`;
const WhiteBox = styled.div`
  margin-top: 8px;
  border: 2px solid ${props => props.theme.colors.lightGrey};
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.siteBlack};
  width: 880px;
  height: 300px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
`;
const MainListItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  padding-left: 48px;
  margin: 4px;
`;
const ListItem = styled.div`
  display: flex;
  align-items: start;
  width: 100%;
  padding-left: 48px;
  margin: 4px;
`;
const EmailLink = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 48px;
  margin: 4px;
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
`;
const TextWrapper = styled.div`
  color: ${props => props.theme.colors.toggleSwitchGrey};
  line-height: 2;
`;
const StyledImage = styled.img`
  mix-blend-mode: darken;
  max-width: 100%;
  height: 380px;
`;
const ImgContainer = styled.div`
  align-self: flex-end;
  margin-right: -32px;
`;

export const SuccessPage = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  // Use window.innerWidth to determine which component to render
  if (typeof window !== 'undefined' && window.innerWidth <= 999) {
    return <SuccessPageMobile />;
  }
  const handleContactUsClick = () => {
    window.open('https://www.rapnet.com/contact/support/', '_blank');
  };
  return (
    <Container>
      <FirstText>{TRANSLATION_TEXT.thank_you_for_subscribing}</FirstText>
      <ThirdText>{TRANSLATION_TEXT.process_your_rapnet_membership}</ThirdText>
      <WhiteBox>
        <MainListItem>
          <BoldText>{TRANSLATION_TEXT.active_business_license_or_certificate}</BoldText>
          <SecondText>{TRANSLATION_TEXT.showing_your_involvement}</SecondText>
        </MainListItem>
        <MainListItem>
          <BoldText>{TRANSLATION_TEXT.government_issued_photo_id}</BoldText>
          <SecondText>{TRANSLATION_TEXT.necessary_for_the_company_owner}</SecondText>
        </MainListItem>
        <MainListItem>
          <BoldText>{TRANSLATION_TEXT.trade_reputation_and_industry_affiliation}</BoldText>
        </MainListItem>
        <ListItem>
          <BoldText>{TRANSLATION_TEXT.two_trade_references}</BoldText>
          <SecondText>{TRANSLATION_TEXT.from_reputable_diamond_or_jewelry_companies}</SecondText>
        </ListItem>
        <ListItem>
          <SecondText>{TRANSLATION_TEXT.last_six_months}</SecondText>
        </ListItem>
        <ListItem>
          <BoldText>{TRANSLATION_TEXT.two_trade_invoices}</BoldText>
          <SecondText>{TRANSLATION_TEXT.dated_within_last_six_months}</SecondText>
        </ListItem>
      </WhiteBox>
      <EmailLink>
        <SecondText>{TRANSLATION_TEXT.please_email_documents}</SecondText>
        <StyledLink>compliance@rapaport.com</StyledLink>
      </EmailLink>
      <TextWrapper>
        <SecondText>{TRANSLATION_TEXT.a_rapnet_representative_will_follow_up_with_you}</SecondText>
        <br />
        <SecondText>
          {TRANSLATION_TEXT.if_you_have_any_questions_please_feel_free}
          <StyledLink onClick={handleContactUsClick}>
            {TRANSLATION_TEXT.contact_us_lower}
          </StyledLink>
        </SecondText>
      </TextWrapper>
      <ImgContainer>
        <StyledImage src={diamondsBackground} />
      </ImgContainer>
    </Container>
  );
};
